
export default{
    // @Business
    newCreatedTechProvider: {},
}